import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  wrapperFloorControls: {
    zIndex: 2,
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'row',
      padding: '20px 20px 20px 0',
      '& > div': {
        width: '100%',
      },
      '& > div:not(:first-child)': {
        marginLeft: '10px',
      },
    },
  },
  floorsContainerWrapper: {
    [theme.breakpoints.down('md')]: {
      display: 'inline-table',
      marginBottom: '0px',
      padding: '20px 0px 0px 20px',
    },
  },
}));
